/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class TosController {
    public static $inject = [
        '$state',
        'toaster',
        'Login',
        'Employee',
        'User'
    ];

    public agree = false;
    private employee;

    constructor (
        private $state: ng.ui.IStateService,
        private toaster: any,
        private Login: ILoginService,
        private Employee: IEmpService,
        private User: IUserService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    public doit(form: angular.IFormController): void {
        if (this.agree) {
            this.acceptToS();
        } else {
            this.toaster.pop('warning', 'You must accept the Terms and Conditions');
        }
    }

    public cancel(form: angular.IFormController): void {
        this.Login.logout().$promise.then(() => {
            //cleaning user-id attr
            angular.element('body').removeAttr('user-id');
            this.User.clearUser();
            this.$state.go('login');
            this.toaster.pop('warning', 'You must accept the Terms and Conditons');
        });
    }

    public acceptToS(): void {
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
            this.Employee.acceptToS(this.employee).then(() => {
            // Do a priv-policy check
            if (this.employee.extra.terms_of_service.pp_agreed) {
                if (!this.employee.extra.dismiss_tour) {
                    this.$state.go('tour');
                } else {
                    this.$state.go('root.home');
                }
            } else {
                this.$state.go('priv');
            }
            });
        });
    }
}

angular.module('beneple.global')
    .controller('TosController', TosController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/tos.ts